

export default {
  name: "RedSection",

  data() {
    return {
      email: '',
      accepted: false,
      errored: false,
      showModal: false,
    }
  },

  methods: {
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    testEmail() {
      if (this.validateEmail(this.email)) {this.errored = false} else {this.errored = true}
    },

    debounceSearch() {
      this.errored = false;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.testEmail()
      }, 1000)
    },

    sendData() {
      this.$axios.post(`${process.env.API_BASE_URL}/api/newsletter/subscribe`, {
        email: this.email,

      })
      this.email = ''
      this.$store.commit('acceptCancel');
      this.errored = false
      this.showModal = true;
      setTimeout(() => this.showModal = false, 4000)

    }
  },


  mounted() {
    this.$store.commit('acceptCancel');
  },

  unmounted() {
    this.$store.commit('acceptCancel');
  },
  props: ['maxh', 'empty', 'title', 'nopad', 'subtitle', 'button']
}
